require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-zg-tgnx.json") })
        }
      }, "path---photos-professional-zg-tgnx");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-zg-tgnx!./.cache/json/photos-professional-zg-tgnx.json
// module id = 1213
// module chunks = 231608221292675